/**
 * @file Re-exports the List component.
 */
import List from "./List";

export default List;
